import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import * as React from 'react';
import { IMiaRouteMatchResponse } from '../components/hooks';
import { DRAWER_WIDTH } from './layoutConstants';
import { LeftNavMenu } from './LeftNavMenu';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawerHeader: {
      ...theme.mixins.toolbar,
      backgroundColor: theme.palette.primary.dark,
      height: theme.mixins.toolbar.minHeight,
      padding: 5
    },
    drawerPaper: {
      height: '100vh',
      overflow: 'auto',
      width: DRAWER_WIDTH + 10,
      [theme.breakpoints.up('md')]: {
        position: 'relative',
        width: DRAWER_WIDTH
      }
    },
    drawerPaperDockedLeft: {
      borderRightColor: 'rgba(0,0,0,0.12)',
      borderRightStyle: 'solid',
      borderRightWidth: 1
    },
    img: {
      height: '100%'
    }
  })
);

interface IDrawerProps {
  isOpen: boolean;
  onClose: () => any;
  matches: IMiaRouteMatchResponse | null;
}

let LeftNav: React.FunctionComponent<IDrawerProps> = ({ isOpen, onClose, matches }) => {
  const classes = useStyles();
  const drawer = (
    <div>
      <div className={classes.drawerHeader}>
        <img className={classes.img} src="https://static.shoremaster.com/img/wfb_llc_circle_white.png" />
      </div>
      <Divider />
      <LeftNavMenu matches={matches} onNavClick={onClose} />
    </div>
  );

  return (
    <div>
      <Hidden mdUp>
        <Drawer
          variant="temporary"
          anchor="left"
          open={isOpen}
          classes={{ paper: classes.drawerPaper }}
          onClose={onClose}
          ModalProps={{ keepMounted: true /* Better open performance on mobile.*/ }}
        >
          {drawer}
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <Drawer
          variant="permanent"
          open
          classes={{ paper: classes.drawerPaper, paperAnchorDockedLeft: classes.drawerPaperDockedLeft }}
        >
          {drawer}
        </Drawer>
      </Hidden>
    </div>
  );
};

LeftNav = React.memo<IDrawerProps>(LeftNav);
export { LeftNav };
